import "./style/avisDesGens.css"
import React from "react";
import Slider from "react-slick";
import object_desk from "../assets/NosProjets/object_desk.png"
import axios from 'axios';
const Opinion = props => (
<div>
<p className="paragStyle">
  « {props.opinion.Description} »
</p>
<div style={{ marginTop: "35px" }}>
  <p className="authorStyle">{props.opinion.Name}, {props.opinion.Position}</p>
</div>
<div>
  <p className="SousAuth">{props.opinion.Company}</p>
</div>
</div>
)
class AvisGens extends React.Component {
  constructor(props) {
    super(props);
  this.state = {
   
    opinions :[],
    company:'CHIFCO'
};
  }

componentDidMount() {
axios.get(`${process.env.REACT_APP_SERVER}`+'/opinions')
.then(response => {
  this.setState({ opinions:response.data})  
})
.catch((error) => {
  console.log(error);
})
}

opinionList() {
return this.state.opinions.map(currentopinion => {
  if (currentopinion.Company != this.state.company){
  return <Opinion opinion={currentopinion}  key={currentopinion._id}/>;
  }
})
}

  render() {
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      arrows: false,
      adaptiveHeight:true,
    };
    return (
      <div>
        <div className="banniere">
          <div style={{ paddingTop: "30px" }}>
            <h1 className="TitleStyle">CE QUE LES GENS DISENT DE NOUS </h1>
          </div>
          <div style={{ marginTop: "42px", position: "relative", zIndex: "8" }}>
            <div className="maxView" style={{ width: "75%", margin: "0 auto" }}>
              <Slider {...settings}>

              {this.opinionList()}
                
              </Slider>
            </div>
            {/* <div  style={{height:"30px",background:"#090770",opacity:"0"}}></div> */}
          </div>
          <div className="divObjectDesk">
            <img className="ObjectDesk" src={object_desk} alt="" />
          </div>
        </div>
      </div>
    );
  }
}
export default AvisGens;


// WEBPACK FOOTER //
// ./src/home/avisDesGens.js